export const useOneShotHook = () => {
  return null;
};
